/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HandbookCategoryResponseList = {
    type: 'array',
    contains: {
        type: 'HandbookCategoryResponse',
    },
};